import { IconDownload, IconLoader2 } from '@tabler/icons-react'
import { format } from 'date-fns'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useGetLatestCalendarDate } from 'src/API/rest.forecast_calender'
import { useReportAPIs } from 'src/API/rest.reports'
import { useStatesAPI } from 'src/API/rest.states'
import { ButtonIconSquare } from 'src/components/buttons'
import { ErrorBoxStandard } from 'src/components/standard.errorbox'
import { InputStandard } from 'src/components/standard.input'
import { SelectStandard } from 'src/components/standard.select'
import { TypographyH2 } from 'src/components/typography'
import { RootState } from 'src/redux/store'
import { toast } from 'src/shadcn/ui/use-toast'



export function StylewiseForecastReport() {
    const currentDate = new Date();
    const [selectedDate, setSelectedDate] = useState(
        currentDate.toISOString().substring(0, 7) // Format: YYYY-MM
    );


    const {
        isErrorlatestCalendarDate,
        isFetchedlatestCalendarDate,
        isFetchinglatestCalendarDate,
        isLoadinglatestCalendarDate,
        latestCalendarDate,
        refetchlatestCalendarDate
    } = useGetLatestCalendarDate({
        trigger: true
    })

    const {
        states,
        isLoading: isLoadingState,
        isError: isErrorState,
        isFetching: isFetchingState
    } = useStatesAPI({
        trigger: true
    });
    const userData = useSelector((state: RootState) => state.user.employeeDetails)
    const [stateSelected, setStateSelected] = useState<number | null>(null)




    const isAnyError = isErrorlatestCalendarDate
    const isAnyFething = isFetchinglatestCalendarDate
    const isLoading = isLoadinglatestCalendarDate

    // const [employeeSelected, setemployeeSelected] = useState<number[]>([])





    const {
        downloadStylewiseTargetReport,
        isdownloadStylewiseTargetReport
    } = useReportAPIs()



    useEffect(
        () => {
            if (latestCalendarDate?.date) {
                setSelectedDate(format(latestCalendarDate?.date, 'yyyy-MM'))
            }
        }, [isLoadinglatestCalendarDate]
    )



    if (isErrorlatestCalendarDate && !isFetchinglatestCalendarDate) {
        return (
            <div className=' grow flex flex-col items-center '>
                <ErrorBoxStandard
                    onRetry={refetchlatestCalendarDate}
                />
            </div>
        )
    }

    return (
        <div className=' grow  flex flex-col overflow-auto items-center '>


            {/* NP style wise */}
            <div className=' grow flex flex-col overflow-hidden bg-white dark:bg-vstargray-900  rounded-md w-full text-center'>
                <div className=' grow flex flex-col overflow-auto p-2 '>
                    <TypographyH2>Stylewise forecast Report</TypographyH2>
                    <div className=' flex gap-2 '>
                        {/* <InputStandard
                            title='Date'
                            placeholder='Date'
                            type='date'
                            disabled
                            value={latestCalendarDate?.date || ''}
                        /> */}
                        <InputStandard
                            title='Date'
                            placeholder='Date'
                            type='month'
                            onChange={(e) => {
                                setSelectedDate(e.target.value)
                            }}
                            disabled={isFetchinglatestCalendarDate}
                            value={selectedDate || ''}
                        />
                        {/* <SelectStandard
                            title='State'
                            onChange={(e) => setStateSelected(Number(e.target.value))}
                            value={stateSelected ? String(stateSelected) : ''}
                            placeHolder='Select State'
                            options={states?.map(state => ({ value: String(state.FM04_StateID), label: state.FM04_StateName })) || []}
                        /> */}
                    </div>

                    <div className=' grow flex flex-col justify-center items-center  w-min mx-auto mt-8'>

                        <ButtonIconSquare
                            className=' mx-auto mb-5'
                            icon={isdownloadStylewiseTargetReport ? <IconLoader2 className='animate-spin' /> : <IconDownload />}
                            onClick={async () => {

                                

                                const response = await downloadStylewiseTargetReport({
                                    date: latestCalendarDate?.date!,
                                })
                                if (response.success === false) {
                                    toast({
                                        title: 'Error',
                                        description: response.message
                                    })
                                } 
                            }}
                            variant='secondary'
                            text='Download'
                        />
                    </div>
                </div>
            </div>

        </div>
    )
}

